<template>
  <!--头部导航栏-->
  <div>
    <div class="head-class">
<!--      <a class="a-head-class" @click="clickMembers()">会员中心</a>-->
<!--      <a class="no-cursor-a-head-class">｜</a>-->
<!--      <a class="a-head-class" @click="toShoppingCart()">购物车</a>-->
<!--      <a class="no-cursor-a-head-class">｜</a>-->
<!--      <a class="a-head-class" @click="onLoginOut()">退出</a>-->
<!--      <a class="no-cursor-a-head-class">｜</a>-->
<!--      <a class="a-head-class" @click="onLoginIn()">{{this.staffName}}</a>-->
<!--      <a class="no-cursor-a-head-class">｜</a>-->
<!--      <a class="a-head-class no-cursor-a-head-class">你好，欢迎访问"康为医药电商平台"</a>-->
    </div>
    <el-dialog
      title="密码修改"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-form ref="form" :model="pwdData" label-width="100px">
        <el-form-item label="新 密 码：">
          <el-input v-model="pwdData.newPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：">
          <el-input v-model="pwdData.confirmPwd" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyPwd()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {login} from "../../api";
  import md5 from "md5";

  export default {
    data(){
      return{
        userInfo:{},
        staffName:"请登录",
        dialogVisible: false,
        pwdData:{
          newPwd:"",
          confirmPwd:""
        }
      }
    },
    methods:{
      onLoginOut(){
        this.$router.push("/login");
        sessionStorage.removeItem("USERINFO");
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      onLoginIn(){
        if(typeof(this.userInfo) == "undefined" || this.userInfo == null ){
          this.$router.push("/login");
        }else{
          this.dialogVisible = true;
          // this.$message.error("当前系统已登录，无需重新登录！");
        }
      },
      clickMembers(){
        if(this.userInfo.BUSINESSID=="" || this.userInfo.BUSINESSID==null) {
          this.$router.push("/members");
        }else{
          this.$router.push("/saleOutQuery")
        }
      },
      modifyPwd(){
        let newPwd = this.pwdData.newPwd;
        let confirmPwd = this.pwdData.confirmPwd;
        if(newPwd!=confirmPwd){
          this.$message.error("两次密码输入不一致，请检查！");
        }else{
          var md5 =require("md5");
          let password = md5(newPwd);
          login({
            M_STAFFID:this.userInfo.STAFFID,
            M_PASSWORD:password,
            M_ACTION:2,
            M_LGNNAME:this.userInfo.LGNNAME
          }).then(res=>{
            console.log(res);
            //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
            // 请求返回数据
            let dataset = res.data.data.DATASET;
            if(dataset.length==0){
              this.$message.error('密码修改失败，请重新修改！');
              return false;
            }else{
              this.dialogVisible = false;
            }
          }).catch(err=>{
            // 请求失败执行
            console.log(err)
          })
        }
      },
      toShoppingCart(){
        this.$router.push("/quickOrders")
      }
    },
    mounted() {
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
      if(typeof(this.userInfo) == "undefined" || this.userInfo == null ){

      }else{
        this.staffName = this.userInfo.STAFFNAME;
      }
    }
  }
</script>

<style scoped>
.head-class{
  background-color: #e3e4e5;
  height: 30px;
}

.a-head-class{
  color: #999;
  font-size: 12px;
  line-height: 30px;
  padding-left: 7px;
  padding-right: 7px;
  float: right;
  cursor:pointer;
}
.a-head-class:hover{
  color: #d24f48;
  text-decoration: underline;
}

.no-cursor-a-head-class{
  color: #999;
  font-size: 12px;
  line-height: 30px;
  padding-left: 7px;
  padding-right: 7px;
  float: right;
  pointer-events: none;
}

.font-input-suffix{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/component/ShortCut.vue